import http from 'services/http-service';

const BannerService = {
    GetAllShownBanner() {
        var response = http.get("/banners");
        return response;
    }
};

export default BannerService;